import React, { useEffect, useState } from "react";
import { Wheel } from "react-custom-roulette";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "react-recompose";
import { wheelData } from "../../../utils/constants";
import { promisify } from "../../../utils/promisify";
import { userActions } from "../../../store/actions";
import wheelMarker from "../../../static/images/wheelMarker.svg";
import MomentOfTruth from "../../Journey/MomentOfTruth";
import { makeShade } from "../../../utils/colorService";
import s from "./styles.module.scss";

const WheelOfFortune = ({ t, task, ended, addWheelPoints, client }) => {
  useEffect(() => {
    const disabled = task?.quantity <= task?.wheelPoints?.spinsCount || ended;
    setButtonDisabled(disabled);
  }, [task?.quantity, task?.wheelPoints?.spinsCount, ended]);

  const wheelBgs = [client?.bgColor || "#fff", makeShade(client?.primaryColor) || "#018281"];
  const wheelTextColors = [client?.primaryTextColor || "#3a3a3a", client?.bgColor || "#fff"];

  const [mustSpin, setMustSpin] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);

  const handleSpinClick = () => {
    const newPrizeNumber = Math.floor(Math.random() * wheelData.length);
    setPrizeNumber(newPrizeNumber);
    setMustSpin(true);
    setButtonDisabled(true);
  };

  const handleStopSpin = () => {
    setMustSpin(false);
    const earnedPoints = Number(wheelData[prizeNumber].value);
    promisify(addWheelPoints, { taskId: task._id, earnedPoints });
  };

  return (
    <>
      {task?.quantity <= task?.wheelPoints?.spinsCount ? (
        <div className={s.wheelResult}>
          <MomentOfTruth active={true} />
          <div className={s.resultHeader}>{t("tasks.resultHeader")}</div>
          <div
            className={s.resultBody}
            dangerouslySetInnerHTML={{
              __html: t("tasks.resultBody", {
                count: task?.wheelPoints?.earnedPoints,
                lblStatuspoints: client?.ranking?.lblStatuspoints,
              }),
            }}
          ></div>
        </div>
      ) : (
        <div className={s.wheel} style={{ transform: "rotate(45deg)" }}>
          <Wheel
            mustStartSpinning={mustSpin}
            prizeNumber={prizeNumber}
            data={wheelData}
            outerBorderWidth={1}
            outerBorderColor="transparent"
            radiusLineWidth={0}
            pointerProps={{
              src: wheelMarker,
              style: { transform: "rotate(-45deg)" },
            }}
            textColors={wheelTextColors}
            backgroundColors={wheelBgs}
            fontSize={35}
            fontWeight="800"
            onStopSpinning={handleStopSpin}
          />
        </div>
      )}
      <button className={s.spinButton} disabled={buttonDisabled} onClick={handleSpinClick}>
        {t("tasks.spinTheWheel")}
      </button>
    </>
  );
};

export default compose(connect(null, userActions))(withTranslation()(WheelOfFortune));
